// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { FileBraces as RawFileBraces } from "lucide-react";
export const FileBraces = /* @__PURE__ */ createIcon(RawFileBraces, "FileBraces", 2);
